import { Link, NavLink } from "react-router-dom";
import { LogOut } from "lucide-react";

const SUB_BADGE_STYLE = {
  active: "border-[#00D4FF] text-[#00D4FF]",
  trialing: "border-amber-400 text-amber-400",
};
const SUB_BADGE_LABEL = {
  active: "PRO",
  trialing: "TRIAL",
};

function subBadgeStyle(status) {
  return SUB_BADGE_STYLE[status] || "border-red-400 text-red-400";
}
function subBadgeLabel(status) {
  return SUB_BADGE_LABEL[status] || "EXPIRED";
}

function navItemClass({ isActive }) {
  const base =
    "flex items-center gap-2 px-4 py-2 text-sm font-mono uppercase tracking-widest transition-colors border border-transparent";
  return isActive
    ? `${base} text-[#00D4FF] border-zinc-800 bg-zinc-900/60`
    : `${base} text-zinc-400 hover:text-white`;
}

function mobileNavItemClass({ isActive }) {
  const base =
    "flex-1 min-w-max flex items-center justify-center gap-2 px-4 py-3 text-xs font-mono uppercase tracking-widest";
  return isActive ? `${base} text-[#00D4FF]` : `${base} text-zinc-500`;
}

export function DesktopNav({ navLinks }) {
  return (
    <nav className="hidden md:flex items-center gap-1">
      {navLinks.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={`nav-${label.toLowerCase()}`}
          className={navItemClass}
        >
          <Icon size={14} strokeWidth={1.5} /> {label}
        </NavLink>
      ))}
    </nav>
  );
}

export function MobileNav({ navLinks }) {
  return (
    <div className="md:hidden border-t border-zinc-800 flex overflow-x-auto">
      {navLinks.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={`mnav-${label.toLowerCase()}`}
          className={mobileNavItemClass}
        >
          <Icon size={14} strokeWidth={1.5} /> {label}
        </NavLink>
      ))}
    </div>
  );
}

export function UserControls({ user, onLogout }) {
  return (
    <div className="flex items-center gap-3">
      <div className="hidden sm:block text-right">
        <div className="overline leading-none">USER</div>
        <div className="text-sm mt-1 mono" data-testid="header-user-email">
          {user?.email}
        </div>
      </div>
      {user?.subscription_status && (
        <Link
          to="/app/billing"
          data-testid="subscription-badge"
          className={`hidden sm:block px-2 py-1 border mono text-[10px] uppercase tracking-widest ${subBadgeStyle(
            user.subscription_status
          )}`}
        >
          {subBadgeLabel(user.subscription_status)}
        </Link>
      )}
      <button
        onClick={onLogout}
        data-testid="logout-button"
        className="flex items-center gap-2 px-3 py-2 border border-zinc-800 hover:border-[#00D4FF] hover:text-[#00D4FF] text-zinc-400 text-xs font-mono uppercase tracking-widest transition-colors"
      >
        <LogOut size={14} strokeWidth={1.5} /> Exit
      </button>
    </div>
  );
}
